export default function Back({ nodeHistory, setNodeHistory, setSelectedNode }) {
	function clickHandler() {
		const node = nodeHistory[nodeHistory.length - 2];
		setNodeHistory((prevState) => prevState.slice(0, -2));
		setSelectedNode(node);
	}

	return nodeHistory.length > 1 ? (
		<button
			className="absolute left-4 top-44 top-adjust-back pointer z-10 back"
			onClick={clickHandler}
		>
			← Back
		</button>
	) : (
		<div />
	);
}
